import script from "./index.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue.less?vue&type=style&index=0&id=1033bb56&lang=less&scoped=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./index.vue?vue&type=style&index=0&id=1033bb56&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1033bb56"]])

export default __exports__